/**
 * 前端查询缓存配置（集中管理，改这里即可全局生效）
 *
 * 背景：服务器带宽有限。开启后，GET 查询结果会在浏览器内存里缓存一段时间，
 * 命中缓存的请求【不再访问服务器】，从而显著减少带宽占用和后端压力。
 *
 * 失效机制：后台管理页面任意“增 / 删 / 改”操作成功后，会自动清除该资源相关的缓存，
 * 下一次查询会重新请求并写入最新数据（即“清除旧缓存 + 重写新缓存”）。
 */

// 缓存有效期（毫秒）。当前：10 分钟。只需改这一行即可全局调整缓存时长。
export const CACHE_TTL = 10 * 60 * 1000

// 缓存总开关。设为 false 可一键关闭全部前端缓存（恢复为每次都请求服务器）。
export const CACHE_ENABLED = true

// 不参与缓存的 URL 关键词（认证接口等实时性要求高的）。
// 提示：产品/方案详情页的 GET 会在后端顺带 +1 浏览量，若希望浏览量精确统计，
//       可把 '/api/products/' 和 '/api/solutions/' 加进下面数组（代价是这两类详情不再省带宽）。
export const CACHE_EXCLUDE_KEYWORDS = [
  '/auth/'
]

// 调试日志开关（默认关闭）。开启后浏览器 Console 会彩色打印每次请求是“命中缓存 / 请求后端 / 失效”。
// 也可不改这里，直接在控制台执行 localStorage.setItem('CACHE_DEBUG','1') 后刷新页面即可临时开启。
export const CACHE_DEBUG = false

// 缓存存储位置（决定“刷新页面后是否仍命中缓存”）：
//   'memory'  仅内存：刷新页面即清空，数据永远最新，但刷新后第一轮请求仍走后端。
//   'session' sessionStorage：刷新仍在、关闭标签页清空，但【每个标签页各自隔离】，
//             后台页改了数据，前台页刷新仍可能看到旧缓存（跨标签页不互通）。
//   'local'   localStorage：持久保存直到过期/手动清除，省带宽最多（默认，推荐）；
//             配合 requestCache.js 的 storage 事件监听，后台在任一标签页改动后，
//             同浏览器内其他已打开标签页会【即时】同步失效，刷新即见最新数据。
//             注意：即时同步仅限【同一浏览器】；其他访客/设备最长可能看到 CACHE_TTL 内的旧数据。
export const CACHE_STORAGE = 'local'